import api from "../../config/client.axios.api";

export const getRevenueAnalysticEachStoreApi = async (
  month: any,
  year: any,
) => {
  const response = await api.get(`/history/get-revenue-analysis-each-store`, {
    params: {
      checkMonth: `${year}-${String(month).padStart(2, '0')}-01`,
    },
  });
  return response.data;
};
